{
  "sidenavMenuCloseTooltip": "Fechar menu",
  "sidenavMenuLockTooltip": "Clique para bloquear o menu",
  "toggleSideNav": "Alternar menu de navegação lateral"
}
